import { c as _c } from "react/compiler-runtime";
import React from 'react';
// import PropTypes from 'prop-types';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import OrderTracking from './components/OrderTrackingPage';
const OrderTrackingPage = props => {
  const $ = _c(6);
  const {
    search
  } = useLocation();
  let t0;
  if ($[0] !== search) {
    t0 = queryString.parse(search);
    $[0] = search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const params = t0;
  const order_id = params.id || params.order_id;
  if (order_id) {
    let t1;
    if ($[2] !== order_id || $[3] !== props) {
      t1 = <OrderTracking orderId={order_id} {...props} />;
      $[2] = order_id;
      $[3] = props;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="order-tracking-page" data-xc="order-tracking-page"><div className="text-lg font-bold tracker-msg">Unable to load tracking details</div></div>;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
OrderTrackingPage.propTypes = {};
export default OrderTrackingPage;